import React from 'react';
export function PainSection() {
  const painPoints = ['Llegás al patio y el grupo se te va de las manos en los primeros 2 minutos.', 'Pasás horas buscando actividades en internet que no tienen progresión pedagógica.', 'El inspector te pide la planificación y sentís que no está a la altura.', 'Repetís los mismos juegos porque "ya sé que funcionan" aunque te aburran a vos también.', 'Terminás cada semana agotado sin saber exactamente qué aprendieron tus alumnos.'];
  return <section className="bg-white py-20 px-4" data-id="element-41">
      <div className="max-w-4xl mx-auto" data-id="element-42">
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 text-center mb-12" data-id="element-43">
          Esto te va a sonar conocido...
        </h2>

        <div className="space-y-6 bg-gray-50 p-8 md:p-10 rounded-2xl border border-gray-100 shadow-sm" data-id="element-44">
          {painPoints.map((point, index) => <div key={index} className="flex items-start" data-id="element-45">
              <span className="text-red-500 text-2xl mr-4 mt-1 flex-shrink-0 leading-none" data-id="element-46">
                🔴
              </span>
              <p className="text-lg md:text-xl text-gray-700 font-medium leading-relaxed" data-id="element-47">
                {point}
              </p>
            </div>)}
        </div>

        <div className="mt-12 text-center mb-16" data-id="element-48">
          <p className="text-xl md:text-2xl font-bold text-gray-900 bg-red-50 inline-block px-6 py-3 rounded-lg border border-red-100" data-id="element-49">
            Si marcaste aunque sea una de estas situaciones, seguí leyendo.
          </p>
        </div>

        <div className="space-y-8 text-lg md:text-xl text-gray-700 leading-relaxed border-t border-gray-200 pt-16" data-id="element-50">
          <p className="font-bold text-gray-900 text-xl md:text-2xl border-l-4 border-[#D4A843] pl-6 py-2" data-id="element-51">
            Nadie te enseñó cómo estructurar una clase real en el mundo real.
          </p>

          <div className="bg-[#0B1A2E] text-white p-8 rounded-xl shadow-lg text-center" data-id="element-52">
            <h3 className="text-2xl md:text-3xl font-bold text-[#F0C14B] mb-4" data-id="element-53">
              El Síndrome del Silbato.
            </h3>
            <p className="text-lg md:text-xl text-gray-300" data-id="element-54">
              Entrás al patio con angustia. Das lo que podés. Salís sin saber si
              valió la pena. Y el domingo volvés a empezar de cero.
            </p>
          </div>

          <p className="text-center font-bold text-xl md:text-2xl text-gray-900 mt-8" data-id="element-55">
            Eso no es tu culpa. Pero sí es tu problema.{' '}
            <span className="text-[#D4A843]" data-id="element-56">Y tiene solución.</span>
          </p>
        </div>
      </div>
    </section>;
}